/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";

import {
  Row,
  Col,
  Card,
  Radio,
  Table,
  Tag,
  Tooltip,
  message,
  Progress,
  Button,
  Avatar,
  Typography,
  Input,
  Spin,
  Space,
  Select,
  Modal,
  Badge,
  Switch
} from "antd";

import { map, includes, sortBy, uniqBy, each, result, get } from "lodash";

import {
  CheckCircleOutlined,
  SearchOutlined,
  FundViewOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
  LoadingOutlined,
  UserSwitchOutlined,
  UserOutlined,
  RedoOutlined,
  UndoOutlined,
  UserDeleteOutlined,
  UserAddOutlined,
  UnlockTwoTone,
  KeyOutlined
} from "@ant-design/icons";

import TableComp from "./../components/TableComp";
import DetailView from "./../components/DetailView";

import ResetUPassword from "./../components/ResetUPassword";
import NetworkStatus from "./NetworkStatus";

import { getAllUsers, getUserDetail, updateRole,softDeleteUser,restoreUser,forceDelete } from "./../services";

const { Search } = Input;
const { confirm } = Modal;
const { Title } = Typography;
const Option = Select.Option;
const authRole =
  ["admin"].indexOf(localStorage.getItem("is_role")) !== -1 ? true : false;

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 60,
    }}
    spin
  />
);

// // table code start
// const columns = [
//   {
//     title: "Name",
//     dataIndex: "name",
//     key: "name",
//     width: "32%",
//     filterSearch: true,
//     filterMode: "tree",
//     onFilter: (value, record) => record.name.startsWith(value),
//   },
//   {
//     title: "Role",
//     dataIndex: "role",
//     key: "user",
//   },

//   {
//     title: "STATUS",
//     key: "status",
//     dataIndex: "status",
//   },
//   {
//     title: "Action",
//     key: "employed",
//     dataIndex: "employed",
//   },
// ];

const pdRoles = [
  {
    label: "Normal",
    value: 1,
    color: "#2db7f5",
  },
  {
    label: "Coach",
    value: 2,
    color: "#f50",
  },
  {
    label: "Developer",
    value: 3,
    color: "#87d068",
  },
  {
    label: "Tester",
    value: 4,
    color: "#108ee9",
  },{
    label: "Researcher",
    value: 5,
    color: "purple",
  }
];

const pdUserStatus = [
 
  {
    label: "Verified",
    value: 1,
    color: "#87d068",
    icon: <CheckCircleOutlined />
  },
   {
    label: "Non-Verified",
    value: 0,
    color: "#ffbf00",
    icon: <ExclamationCircleOutlined />
  },
  {
    label: "Deleted",
    value: 2,
    color: "#f50",
    icon: <DeleteOutlined />
  }
];


const getRolelabel = (currentRole) => {
  const roleInfo = pdRoles.find((role) => role.value === currentRole);

  return (
    <Tag color={roleInfo.color}>
      <b>{roleInfo.label}</b>
    </Tag>
  );
};

const getUsrStatus = (currentSts) => {

  // console.log(currentSts);
  const uStatus = pdUserStatus.find((role) => role.value === currentSts);

  return (
    <Tag icon={uStatus.icon} color={uStatus.color}>
      <b>{uStatus.label}</b>
    </Tag>
  );
};

const data = [];

class Tables extends React.Component {
  state = {
    mainResponse: [],
    usersList: [],
    currentUser: false,
    isLoader: true,
    userListState: [],
    filteredInfo: null,
    sortedInfo: null,
    dataStore:[],
    currentState:[],
    filtered: false,
    searchText: "",
    mainFilter:{},
    currentFilter:"User Status",
    isModalVisible: false,
    selectedUser:{},
  };

  componentDidMount() {
    this.initUserLists();
  }


 // Function to show the modal
  showModal = (thisRecord) => {


    this.setState({ selectedUser:thisRecord,isModalVisible: true });
  };

  // Function to hide the modal
  handleCancel = () => {
    this.setState({ selectedUser:{},isModalVisible: false });
  };

  initUserLists = async () => {
    const { message, status } = await getAllUsers({livemode:false});
    // console.log(message,status);
    if (status == "success") {
      const { activeUsers, deletedUsers } = message;
      console.log("FIRE");

      this.setState({mainResponse:message});

      this.thisLiveData(activeUsers,"active");
      // getUserDetail
    }
  };

  thisLiveData = (liveData,typeDef) =>{

        this.usersListMake(liveData);

        this.setState({
          currentState:liveData,
          userListState: liveData,
          isLoader: false,
        });

  }

  syncLiveRunners =async (state) =>{

      const { message, status } = await getAllUsers({livemode:state});

      if (status == "success") {
      const { activeUsers, deletedUsers } = message;
      console.log("FIRE");

      this.setState({mainResponse:message});

      this.thisLiveData(activeUsers,"active");
      // getUserDetail
      }
  }

  onChangeLiveRunners =(checked) =>{

    if(checked){
      localStorage.setItem("livemode",true);

      this.syncLiveRunners(true);

    } else {

      localStorage.removeItem("livemode");

      this.syncLiveRunners(false);
    }

  }


  async SelectUser(thisUserObj) {
    console.log(thisUserObj);

    let thisMessage = message;
    thisMessage.loading({
      content: "Loading...",
      key: "all_runs",
    });

    const thisData = await getUserDetail(thisUserObj);
    const { status } = thisData;

    if (status) {
      thisUserObj.run_list = thisData.message;
      this.setState({
        currentUser: thisUserObj,
      });

      thisMessage.success({
        content: "Loaded!",
        key: "all_runs",
        duration: 2,
      });
    } else {
      thisMessage.error({
        content: "Not Loaded!",
        key: "all_runs",
        duration: 2,
      });
    }
  }

  randomIntFromInterval(min, max) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  showPromiseConfirm = (content) => {
    const thisState = this;
    confirm({
      title: "Do you want to change the role?",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        return new Promise(async (resolve, reject) => {
          const thisData = await updateRole(content);

          if (thisData.status === "success") {
            message.success(thisData.message);

            // thisState.initUserLists();
            window.location.reload();
            resolve(true);
          } else {
            message.error(thisData.message);
            reject(true);
          }

          // setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
        }).catch(() => console.log("Oops! Something went wrong"));
      },
      onCancel() {
        // console.log("fdsfdf");
        window.location.reload();

        // thisState.initUserLists();
      },
    });
  };


   showDeletePromiseConfirm = (content,_type) => {
    const thisState = this;
    confirm({
      title: (_type=="delete" ? "Do you want to Delete this user?" : (_type=="force" ? "Do you want to Delete this user permanently?" : "Do you want to Restore this user?" )),
      icon: <ExclamationCircleOutlined />,
      onOk() {
        return new Promise(async (resolve, reject) => {


          const thisData = await (_type=="delete" ? softDeleteUser(content) : (_type=="force" ? forceDelete(content) : restoreUser(content)));

          if (thisData.status === "success") {
            message.success(thisData.message);

            thisState.setState({
              currentFilter: 1
            })  
            thisState.initUserLists();
            // window.location.reload();
            resolve(true);
          } else {
            message.error(thisData.message);
            reject(true);
          }

          // setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
        }).catch(() => console.log("Oops! Something went wrong"));
      },
      onCancel() {


        // console.log("fdsfdf");
        // window.location.reload();

        // thisState.initUserLists();
      },
    });
  };

  triggerDelete = (value) => {
    console.log(value);

    this.showDeletePromiseConfirm(value,"delete");
  };

  triggerRestore= (value) => {

      console.log(value);
      this.showDeletePromiseConfirm(value,"restore");

  };

  forceDelete= (value) => {
      console.log(value);
      this.showDeletePromiseConfirm(value,"force");

  };

  roleChange = (value, usrObj) => {
    console.log(value, usrObj);

    usrObj.role = value;

    this.showPromiseConfirm(usrObj);
  };

  usersListMake = (user_list) => {
    let currentList = [];
    const ColorList = ["#f56a00", "#7265e6", "#ffbf00", "#00a2ae"];




    if (user_list.length > 0) {
      user_list.forEach((element, index) => {
        // console.log(element)
        currentList.push({
          key: index,
          name: (
            <>
              <Avatar.Group>
                <Avatar
                  className="shape-avatar"
                  shape="square"
                  size={40}
                  style={{
                    backgroundColor:
                      ColorList[this.randomIntFromInterval(0, 3)],
                    verticalAlign: "middle",
                  }}
                >
                  { (element.name ?  (element.name.split(" ").length > 1 ? element.name.split(" ")[0][0] + element.name.split(" ")[1][0] : element.name[0] )  : element.name)}
                </Avatar>
                <div className="avatar-info">
                  <Title level={5}>{element.name}</Title>
                  <p>{element.email}</p>
                </div>
              </Avatar.Group>{" "}
            </>
          ),
          role: (
            <>
              <div className="author-info">
                <Title level={5}>Project Dasein</Title>
                <p>{getRolelabel(element.role)}</p>
              </div>
            </>
          ),

          status: (
            <>{element.status ? <Tag icon={<CheckCircleOutlined />} color="success">
                Verified
              </Tag> : <Tag color="warning">Non-Verified</Tag> }
              
            </>
          ),
          employed: (
            <>
              <div className="ant-employed">
                <span>
                 
                  <Button
                    onClick={() => this.SelectUser(element)}
                    type="primary"
                    icon={<FundViewOutlined />}
                    size={"large"}
                  >
                    {" "}
                    View Runs{" "}
                  </Button>

              <Tooltip title="Reset Password">
                   <Button
                    onClick={() => this.showModal(element)}
                    type="default"
                    icon={<UnlockTwoTone /> }
                    size={"large"}
                    style={{borderRadius:"15px", margin:"0 5px"}}

                  ><KeyOutlined /></Button>
                  </Tooltip>
              
                    
               
                  {authRole ? (
                    <span>
                    

                    
                    {
                      (element.is_deleted ? <span><Tooltip title="Restore User">
                  <Button
                    onClick={() => this.triggerRestore(element)}
                    style={{borderRadius:"15px",backgroundColor:"#1bb11b",color:"#fff"}}
                    type="default"
                    
                    size={"large"}
                  > <span> <UserAddOutlined /><UndoOutlined /></span>
                  </Button>
                  </Tooltip>
                  <Tooltip title="Delete User">
                  <Button
                    onClick={() => this.forceDelete(element)}
                    style={{borderRadius:"15px"}}
                    type="danger"
                    
                    size={"large"}
                  > <span> <DeleteOutlined /></span>
                  </Button>
                  </Tooltip></span>
                   :    (element.role!==4 ? <Tooltip title="Delete User">
                
               <Button
                    onClick={() => this.triggerDelete(element)}
                    style={{borderRadius:"15px"}}
                    type="danger"
                    
                    size={"large"}
                  > <span> <UserDeleteOutlined /><DeleteOutlined /></span>
                  </Button>
                  </Tooltip> : "" ) )
                    }
                   &nbsp;
                  {(element.role!==4  ?  <Select
                      defaultValue={parseInt(element.role)}
                      size="large"
                      dropdownMatchSelectWidth={true}
                      suffixIcon={<UserSwitchOutlined />}
                      menuItemSelectedIcon={<UserSwitchOutlined />}
                      options={pdRoles}
                      onChange={(value) => this.roleChange(value, element)}
                    /> : "" )}
                    </span>

                  ) : (
                    ""
                  )}
                  
                  
                  
                </span>
              </div>
            </>
          ),
        });
      });
    }

    //  console.log(currentList);

    this.setState({
      usersList: currentList,
    });
  };

  onCloseParent = (et) => {
    this.setState({
      currentUser: false,
    });
  };

  // onSearch = (e) => {
  //   const { value } = e.target;

  //   let { userListState } = this.state;

  //   userListState = userListState.filter(
  //     (userItem) =>
  //       userItem.email.indexOf(value) !== -1 ||
  //       userItem.first_name.indexOf(value) !== -1 ||
  //       userItem.last_name.indexOf(value) !== -1
  //   );

  //   this.usersListMake(userListState);
  // };

   onSearch = e => {
    
    const {currentState}  = this.state; 

    const reg = new RegExp(e.target.value, "gi");
    const filteredData = map(currentState, record => {
      const nameMatch = get(record, "name").match(reg);
      const addressMatch = get(record, "email").match(reg);
      if (!nameMatch && !addressMatch) {
        return null;
      }
      return record;
    }).filter(record => !!record);

    this.setState({
      searchText: e.target.value,
      filtered: !!e.target.value,
    });

    this.usersListMake(e.target.value ? filteredData : currentState);
  };

  thisDetailSync = () => {
    // console.log("ROOT SYNC");

    const { currentUser } = this.state;

    this.SelectUser(currentUser);
  };

  onChange = (e) => console.log(`radio checked:${e.target.value}`);


  handleChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, filters, sorter);
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter
    });
  };


   handleFilter = (value, option) => {
    console.log(value);

    const {currentState,userListState,mainFilter,mainResponse}  = this.state;

          let thisFilterData = [];

          if(mainFilter.role && parseInt(mainFilter.role)!=parseInt(value)){
              thisFilterData = userListState;
          } else if (mainFilter.status && mainFilter.status!=value && value!==2){
              thisFilterData = userListState;
          }   
           else {
            thisFilterData =  currentState;
          }

          if(option=="status" && value==2){
            thisFilterData = mainResponse.deletedUsers;
          }


          const filterRole =  map(thisFilterData, record => {

            let  filterMatch = false;

            if(option=="status" && (value ==1 || value ==0) ){
               
                filterMatch = (record.status===(value ==1 ? true : false));
            }

            if(option=="status" && value ==2){
               
                filterMatch = true;
            }

            if(option=="role") {
               filterMatch = (parseInt(record.role)===parseInt(value));
            }

            if (!filterMatch) {
              return null;
            }
            return record;
          }).filter(record => !!record);


         if(option=="role") {
            mainFilter.role = value;   
         } 

         if(option=="status") {
            mainFilter.status = value;   

          this.setState({
            currentFilter: parseInt(mainFilter.status)
          });
         } 
         
        
        this.setState({
            currentState:filterRole,
            mainFilter
        }); 
         this.usersListMake(filterRole);


  };


    clearAll = () => {
        const {userListState}  = this.state;
      this.setState({
        filteredInfo: null,
        sortedInfo: null,
        searchText: "",
        filtered: null,
        mainFilter:{}
      });

      this.usersListMake(userListState);
      this.initUserLists();
  };

   getFilterOption(pdContext) {
    let Filters = [];
      each(pdContext, e => {
        Filters.push(<Option key={e.value}><Badge color={e.color} text={e.label} /></Option>);
      });
    return Filters;
  }


  render() {
    const { usersList, userListState, currentUser, isLoader,isModalVisible,selectedUser } = this.state;


      let { sortedInfo, filteredInfo } = this.state;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};

    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        filteredValue: filteredInfo.name || null,
        onFilter: (value, record) => record.name.includes(value),
        sorter: (a, b) => (a.name > b.name ? 1 : -1),
        sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
      },
      {
        title: "STATUS",
        key: "status",
        dataIndex: "status",
      },
      {
        title: "Action",
        key: "employed",
        dataIndex: "employed",
      }
    ];

  

    const getRoles = this.getFilterOption(pdRoles);
    const getUstatus = this.getFilterOption(pdUserStatus);

    const { searchText } = this.state;
    const suffix = searchText ? (
      <span type="close-circle" onClick={this.emitEmpty} >CL </span>
    ) : null;

    return (
      <>
        <div className="tabled">
          {currentUser ? (
            <DetailView
              onCloseParent={this.onCloseParent}
              sync={this.thisDetailSync}
              props={currentUser}
            />
          ) : (
            ""
          )}

          <Row gutter={[24, 0]}>
            <Col xs="24" xl={24}>
              <Card
                bordered={false}
                className="criclebox tablespace mb-24"
                title={<span>PD User List  {(typeof this.state.currentFilter ==="string" ? getUsrStatus(1)  : getUsrStatus(this.state.currentFilter) )}       <Tag color="gold">Total : {usersList.length}</Tag>
 </span>}
                extra={
                  <Input
                    placeholder="Search"
                    onChange={this.onSearch}
                    size="small"
                    suffix={suffix}
                    prefix={<SearchOutlined />}
                  />
                }
              >
                <Spin indicator={antIcon} spinning={isLoader}>
                  <div className="table-responsive">
                    {/*<TableComp dataSource={userListState} />*/}



                   <div className="table-operations">
                   

                      <Button size="small" onClick={this.clearAll}><RedoOutlined /> Clear </Button>

                       <Select
                       size="large"
                        notFoundContent={"Not found?!"}
                        onChange={(value)=> this.handleFilter(value,'status')}
                        defaultValue={"User Status"}
                        value={"User Status"}
                      >
                        {getUstatus}
                      </Select>

                      <Select
                       size="large"
                        notFoundContent={"Not found?!"}
                        onChange={(value)=> this.handleFilter(value,'role')}
                        defaultValue={"User Role"}
                      >
                        {getRoles}
                      </Select>

                     <Button  ><SyncOutlined /> Sync Live Runners  &nbsp;&nbsp; <Switch defaultChecked={localStorage.livemode ? true : false } onChange={this.onChangeLiveRunners} /></Button>
                    
                    </div>
                    
                    <Table
                      columns={columns}
                      dataSource={usersList}
                      rowKey={record => record.id}
                      pagination={true}
                      onChange={this.handleChange}
                      className="ant-border-space"
                    />


                   {isModalVisible ?  <ResetUPassword user={selectedUser}  visible={isModalVisible} onClose={this.handleCancel} /> : ""}
                  </div>
                </Spin>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default Tables;
